import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from "@angular/core";
import { v4 } from "uuid";

/**
 * This component implement a back arrow with "back" label.
 * It manages accessibility attributes for you.
 * And takes its inputs from its parents.
 * Usage:
 * ```
 * <h-back-button-deprecated (goBack)="handleGoBack()">
 *   Libellé du bouton
 * </h-back-button-deprecated>
 * ```
 */
@Component({
    imports: [],
    selector: "h-back-button-deprecated",
    templateUrl: "./back-button-deprecated.component.html",
    styleUrls: ["./back-button-deprecated.component.scss"],
})
export class BackButtonDeprecatedComponent {
    @ViewChild("backButton")
    public backButton: ElementRef | undefined;
    /**
     * EventEmitter when user clicked on back-button
     */
    @Output()
    public goBack: EventEmitter<void> = new EventEmitter<void>();

    /**
     * Automatically add padding & margin to the element
     * */
    @Input()
    public autoAddMargin = true;

    /**
     * allows you to determine if you want to use one or the other svg
     */
    @Input()
    public displaySmallMobileBackButton = false;

    public buttonId: string = v4();

    /**
     * Handle click on button and emit event
     */
    public handleGoBack(): void {
        this.goBack.emit();
    }

    public focus(): void {
        if (this.backButton && this.backButton.nativeElement) {
            this.backButton.nativeElement.focus();
        }
    }
}
